import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

export default function Footer() {
  const { t, lang } = useI18n();
  return (
    <footer className="border-t border-black/5 bg-[#f5f5f7] mt-24" data-testid="site-footer">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <div className="font-semibold text-[15px] tracking-tight mb-4">Tafo</div>
          <p className="text-[13px] text-[#86868b] leading-relaxed">
            {lang === "fr"
              ? "Une approche intégrée de l'immobilier premium."
              : "An integrated approach to premium real estate."}
          </p>
        </div>
        <div>
          <div className="text-[12px] uppercase tracking-[0.2em] text-[#86868b] mb-4">
            {lang === "fr" ? "Services" : "Services"}
          </div>
          <ul className="space-y-2">
            <li><Link to="/vente" className="text-[13px] text-[#1d1d1f] hover:opacity-60">{t.nav.sale}</Link></li>
            <li><Link to="/location-longue" className="text-[13px] text-[#1d1d1f] hover:opacity-60">{t.nav.rentalLong}</Link></li>
            <li><Link to="/location-saisonniere" className="text-[13px] text-[#1d1d1f] hover:opacity-60">{t.nav.rentalShort}</Link></li>
            <li><Link to="/conseil" className="text-[13px] text-[#1d1d1f] hover:opacity-60">{t.nav.consulting}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[12px] uppercase tracking-[0.2em] text-[#86868b] mb-4">
            {lang === "fr" ? "Entreprise" : "Company"}
          </div>
          <ul className="space-y-2 text-[13px] text-[#1d1d1f]">
            <li>{lang === "fr" ? "À propos" : "About"}</li>
            <li>{lang === "fr" ? "Carrières" : "Careers"}</li>
            <li>{lang === "fr" ? "Presse" : "Press"}</li>
          </ul>
        </div>
        <div>
          <div className="text-[12px] uppercase tracking-[0.2em] text-[#86868b] mb-4">Contact</div>
          <ul className="space-y-2 text-[13px] text-[#1d1d1f]">
            <li>Antananarivo, MADAGASCAR</li>
            <li>+261 3 4 34 34 34</li>
            <li>hello@tafo-test.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/5">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <div className="text-[12px] text-[#86868b]">© {new Date().getFullYear()} Tafo. {lang === "fr" ? "Tous droits réservés." : "All rights reserved."}</div>
          <div className="text-[12px] text-[#86868b]">{lang === "fr" ? "Mentions légales · Confidentialité" : "Legal · Privacy"}</div>
        </div>
      </div>
    </footer>
  );
}
